import {ChatList} from '@components/right-panel/chat-list/chat-list'
import {ChatListItem} from '@components/right-panel/task-chat-list/task-chat-list-content'
import {useSyncEvent} from '@containers/hooks'
import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {ChatMessage, DataObjectId} from 'yougile-model'
import {useMessageForwardingStore} from '../message-forwarding-store'

interface Props {
  onSelect: (message: ChatMessage) => void
}

export const List = observer(({onSelect}: Props) => {
  const [state, store] = useMessageForwardingStore()
  useEffect(() => {
    store.setChats()
  }, [])
  useSyncEvent(
    'current',
    {
      debounceTime: 1000,
      filter: '*'
    },
    () => {
      store.setChats()
    }
  )
  const itemClick = (chatId: DataObjectId): void => {
    store.itemClick(chatId, onSelect)
  }
  return (
    <ChatList
      chats={state.chats}
      itemClick={itemClick}
      chatView={ChatListItem}
    />
  )
})
